import { useCallback, useRef, useState } from 'react';
import styles from './ColourSelector.module.scss';
import { HexColorPicker } from 'react-colorful';
import useClickOutside from '@casops/hooks/useClickOutside';
import { VdsCard } from '@volt/volt-extended-components-react';
import VdsBasicInputSafe from '@cas/components/vds-basic-input-safe/VdsBasicInputSafe';
import ColourButton from '@casops/components/inputs/colour-button/ColourButton';
import { useTranslation } from 'react-i18next';

export interface ColourSelectorProps {
  label: string;
  colour: string;
  onChange?: (colour: string) => void;
}

export default function ColourSelector({ label, colour, onChange }: ColourSelectorProps) {
  const { t } = useTranslation();
  const popover = useRef<HTMLDivElement | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const closePopover = useCallback(() => setIsOpen(false), []);

  useClickOutside(popover, () => {
    isOpen && closePopover();
  });

  const onClickButton = useCallback(() => {
    setIsOpen(prev => !prev);
  }, []);

  return (
    <div className={styles.selector} ref={popover}>
      <ColourButton colour={colour} onClick={onClickButton} />
      {isOpen && (
        <VdsCard className={styles.card} shadowBox="elevation-shadow-0">
          <span className={styles.labelColourSelector}>{t('Fields.colourSelector')}</span>
          <HexColorPicker color={colour} onChange={onChange} />
          <span className={styles.labelColourHex}>{t('Fields.colourHex')}</span>
          <VdsBasicInputSafe key="colour" value={colour} isReadonly={true} />
        </VdsCard>
      )}
    </div>
  );
}
